import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

export interface MenuItem {
  id: string
  text: string
  path?: string
  children?: MenuItem[]
  /** 사이트맵(메가메뉴 오버레이) 노출 여부 — 'N' 인 경우 사이트맵에서 제외. */
  smap_use_yn?: string
}

export const exactMatchPaths = new Set<string>([])

const MenuContext = createContext<MenuItem[]>([])

export function useMenuContext(): MenuItem[] {
  return useContext(MenuContext)
}

export function MenuProvider({ children, menus }: { children: ReactNode; menus: MenuItem[] }) {
  return <MenuContext.Provider value={menus}>{children}</MenuContext.Provider>
}